import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Stock } from '../interfaces/stock.interface';
import { StockService } from "../services/stock";
import {RouterLink,Router} from '@angular/router';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder  } from '@angular/forms';

@Component({
  selector: 'app-stock',
  imports: [RouterLink, FormsModule, ReactiveFormsModule, DatePipe],
  templateUrl: './stock.html',
  styleUrl: './stock.css'
})
export class StockComponent {

  public stocks: Stock[] = [];
  myForm: FormGroup;


  constructor(private stockService: StockService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private fb: FormBuilder) 
    {
      this.myForm = this.fb.group(
          {
            datelimit: new FormControl(new Date().getFullYear())
          });
      this.getStocks();
    }


  public async getStocks(): Promise<void> {
      /* this.customerService.getCustomers().subscribe(
        data => this.customers = data,
      error => console.error('Error fetching data:', error)
      ); */
      try {
        this.stocks = await this.stockService.getStocks();
        this.cdr.detectChanges();
        //this.customers = this.customerService.customers;
        } 
        catch (error) 
        {
          console.error('getstocks',error);
      }
  }
    


  onEdit( stock: Stock ): void{
     this.stockService.selectedStock = stock;
      this.router.navigateByUrl('editstock');
   }

   onAdd(): void{
      // this.stockService.selectedStock = {} as Stock;
       this.router.navigateByUrl('addstock')
    }

    async deleteStock( stock: Stock ): Promise<void>{
      const confirmation = window.confirm(`Are you sure you want to delete ${stock.productcode + " - " + stock.pdescription}?`);
      if (!confirmation) {
        return;
      }
      try
        {
          await this.stockService.deleteStock(stock.id);
           this.getStocks();
           this.cdr.detectChanges();
           this.router.navigateByUrl('stock')

        } catch (error) {
          console.error('deletestock error',error);
        }
    }
}
